// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__koHdz","wrapper":"styles_wrapper__p94y3","navigateContainer":"styles_navigateContainer__7nbe4"};